import { render, staticRenderFns } from "./ComparadorArticulo.vue?vue&type=template&id=1cb53b8a&scoped=true"
import script from "./ComparadorArticulo.vue?vue&type=script&lang=js"
export * from "./ComparadorArticulo.vue?vue&type=script&lang=js"
import style0 from "./ComparadorArticulo.vue?vue&type=style&index=0&id=1cb53b8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb53b8a",
  null
  
)

export default component.exports